<app-dialog-base class="modalcreateuser" [Title]='"Users"|translate' [dialogId]="dialogId" (onClose)="close()"
                 (onSubmit)="submit()" [isSubmitDisabled]="isLoading" [isLoading]="isLoading">
  <div class="btn_tabs">
    <a [class.active]="isTabSelected('allUsers')" *ngIf="canAccessUsers()" (click)="selectTab('allUsers')">{{ 'Users' | translate }}</a>
    <a [class.active]="isTabSelected('myProfile')" (click)="selectTab('myProfile')">{{ 'My profile' | translate}}</a>
  </div>

  <div class="horseparator"></div>

  <div id="allUsers" *ngIf="isTabSelected('allUsers') && canAccessUsers()" class="tablewrap">
    <div class="navblock">
      <button class="btnadd" (click)="openCreateModal()">
        {{ 'Add user' | translate }}
      </button>
      <input type="text" class="searchinput" placeholder="{{ 'Find by name' | translate }}" [(ngModel)]="term" />
    </div>
    <div class="tablewrap">
      <div class="table">
        <table fixedcols="[4]" id="subuserslist">
          <tr>
            <th>{{ 'Account' | translate }}</th>
            <th>{{ 'Role' | translate }}</th>
            <th>{{ 'Objects' | translate }}</th>
            <th>{{ 'Geozones' | translate }}</th>
            <th>&nbsp;</th>
          </tr>
          <tr *ngFor="let user of users | filter : term : 'Name'"
              [ngClass]="{'choosed': user.Name == usersService.getUserName()}">
            <td (click)="userSelected(user.Id, user.Name)">{{user.Name}}</td>
            <td (click)="userSelected(user.Id, user.Name)">{{user.RoleDisplayName() | translate}}</td>
            <td (click)="userSelected(user.Id, user.Name)">{{user.ObjectsCount}}</td>
            <td (click)="userSelected(user.Id, user.Name)">{{user.GeozonesCount}}</td>
            <td>
              <button class="btn_img btn_edit" title="{{'Edit'|translate}}" *ngIf="usersService.IsPermitted(AccessRights.EDITUSERS)"
                      (click)="openEditModal(user)"></button>
              <button (click)="deleteUser(user)" class="btn_img btn_trush" *ngIf="usersService.IsPermitted(AccessRights.EDITUSERS)"
                      title="{{'Delete'|translate}}"></button>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
  <div id="myProfile" *ngIf="isTabSelected('myProfile')" class="tablewrap">
    <div class="table">
      <div class="datablock">
        <div class="inputgroup">
          <label>{{"Account"|translate}}</label>
          <input placeholder="{{'Account'|translate}}" type="text" [(ngModel)]="user.Name"
                 [readonly]="user.Id > 0" />
        </div>
        <div class="inputgroup">
          <label>{{'Phone №'|translate}}</label>
          <input placeholder="{{'Phone №'|translate}}" type="text" [(ngModel)]="user.PhoneNumber" />
        </div>
        <div class="inputgroup">
          <label>{{'Email'|translate}}</label>
          <input placeholder="{{'Email'|translate}}" type="text" [(ngModel)]="user.Email"
                 [readonly]="user.Id > 0" />
        </div>
      </div>
      <div class="blockheader">{{'Geolocation and language'|translate}}</div>
      <div class="datablock">
        <div class="inputgroup">
          <label>{{'Timezone'|translate}}</label>
          <select title="{{'Timezone'|translate}}" [(ngModel)]="user.TimeZone">
            <option *ngFor="let timezone of timezones" value="{{timezone.Name}}" [selected]="user.TimeZone === timezone.Name">
              {{timezone.DisplayName}}
            </option>
          </select>
        </div>
        <div class="inputgroup">
          <label>{{'Language'|translate}}</label>
          <select title="{{'Language'|translate}}" [(ngModel)]="user.Language">
            <option *ngFor="let language of languages" value="{{language.code}}"
                    [selected]="user.Language.toLowerCase() == language.code">
              {{language.discription}}
            </option>
          </select>
        </div>
        <div class="inputgroup">
          <label>{{'Geocoding service'|translate}}</label>
          <select title="{{'Geocoding service'|translate}}" [(ngModel)]="user.Geocoder">
            <option *ngFor="let geocoder of geocoders" value="{{geocoder.Name}}"
                    [selected]="user.Geocoder == geocoder.Name">
              {{geocoder.Name|translate}}
            </option>
          </select>
        </div>
        <div class="inputgroup">
          <label>{{'System of units'|translate}}</label>
          <select title="{{'System of units'|translate}}" (change)="onChangeUnits($event)">
            <option value="" [selected]="!user.HasFlag('MILES')">{{'Metric'|translate}}</option>
            <option value="MILES" [selected]="user.HasFlag('MILES')">{{'Imperial (foots/miles)'|translate}}</option>
          </select>
        </div>
      </div>
      <div class="blockheader">{{'Change password'|translate}}</div>
      <div class="datablock">
        <div class="inputgroup">
          <label>{{'Password'|translate}}</label>
          <input placeholder="{{'Password'|translate}}" type="password" [(ngModel)]="changePasswordModel.OldPassword" />
        </div>
        <div class="inputgroup">
          <label>{{'New password'|translate}}</label>
          <input placeholder="{{'New password'|translate}}" type="password"
                 [(ngModel)]="changePasswordModel.Password" />
        </div>
        <div class="inputgroup">
          <label>{{'Password confirmation'|translate}}</label>
          <input placeholder="{{'Password confirmation'|translate}}" type="password"
                 [(ngModel)]="changePasswordModel.PasswordConfirmation" />
        </div>
        <div class="inputgroup">
          <label class="addinfo">&nbsp;</label>
          <button class="btn_blue" (click)="changePassword()">{{'Change password'|translate }}</button>
        </div>
      </div>
    </div>
  </div>
</app-dialog-base>
<template #mgmtDialog></template>

<!--<app-create-user (onCreated)="refresh()" #createModal [dialogId]="'createUserFromDialog'"></app-create-user>-->
<!--<app-edit-user (onCreated)="refresh()" #editModal [dialogId]="'editUserFromDialog'"></app-edit-user>-->
